type QuestionsTabProps = {
  data: string[];
  setData: (questions: string[]) => void;
  newQuestion: string;
  setNewQuestion: (val: string) => void;
};

export default function QuestionsTab({
  data,
  setData,
  newQuestion,
  setNewQuestion,
}: QuestionsTabProps) {
  const addQuestion = () => {
    const trimmed = newQuestion.trim();
    if (trimmed && !data.includes(trimmed)) {
      setData([...data, trimmed]);
    }
    setNewQuestion('');
  };

  const removeQuestion = (i: number) => {
    setData(data.filter((_, idx) => idx !== i));
  };

  return (
    <div>
      <h2 className="text-[#6E3EF5] text-lg mb-5">Questions</h2>

      <div className="flex flex-col gap-2.5 mb-5">
        {data.map((question, i) => (
          <div
            key={i}
            className="px-4 py-3 bg-[#F9F6FF] border border-[#F0F0F0] rounded-lg flex justify-between items-center"
          >
            <span className="text-sm text-gray-700">{question}</span>
            <button
              onClick={() => removeQuestion(i)}
              className="text-gray-300 hover:text-red-500 text-lg leading-none px-1 transition-colors cursor-pointer bg-transparent border-none"
            >
              ×
            </button>
          </div>
        ))}
      </div>

      <div className="flex gap-2">
        <input
          value={newQuestion}
          onChange={(e) => setNewQuestion(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && addQuestion()}
          placeholder="Add a new question..."
          className="flex-1 px-4 py-2.5 border border-[#F0F0F0] rounded-lg bg-black/[0.004] text-sm outline-none focus:border-violet-600 transition-colors"
        />
        <button
          onClick={addQuestion}
          className="px-4 py-2.5 bg-violet-100 text-violet-700 font-semibold text-sm rounded-xl hover:bg-violet-200 transition-colors cursor-pointer border-none"
        >
          + Add
        </button>
      </div>
    </div>
  );
}
